export var valuesPPNIdKnown = ["None", "PPX", "PPN"];
/*

*/ 
//# sourceMappingURL=PPNIdKnown.js.map